import { Divider, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import {
  StyledProductSubTitle,
  StyledProductTitle,
} from "@Styled/Pages/Landing";
import { IProductDetailProdps } from "../..";
import DescriptionTabs from "./DescriptionTabs";
import dynamic from "next/dynamic";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import Icon from "@mui/material/Icon";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CartActions } from "@Redux-Store/Actions";
import { StyledGreenButton, StyledLightGreenButton } from "@Styled/Common";
import Spinner from "@Components/Pages/Common/Spinner";

// import Pricing from "./Pricing";
// import Rating from "./Rating";
// import Variants from "./Variants";
const Reviews = dynamic(() => import("./Reviews"), { ssr: false });
const Rating = dynamic(() => import("./Rating"), { ssr: false });
const Variants = dynamic(() => import("./Variants"), { ssr: false });
const Pricing = dynamic(() => import("./Pricing"), { ssr: false });

export default function ProductDetailsRighttTop({
  product,
}: IProductDetailProdps) {
  const theme = useTheme();
  const smPlus = useMediaQuery(theme.breakpoints.up("sm"));

  const dispatch = useDispatch();
  const [isViewCartButtonVisible, setIsViewCartButtonVisible] = useState<
    boolean
  >(false);

  const spinner = useSelector((state) => state?.CartReducer.loader);
  const cartData = useSelector((state) => state?.CartReducer.cart);

  useEffect(() => {
    if (cartData) {
      cartData?.cartItems.forEach((element) => {
        setIsViewCartButtonVisible(false);
        if (element.product._id == product._id) {
          setIsViewCartButtonVisible(true);
        }
      });
    }
  }, [cartData, product]);

  const handleAddToCart = async () => {
    const cart = {
      productId: product._id,
      quantity: 1,
    };
    dispatch(CartActions.AddToCart(cart));
  };

  return (
    <Box>
      <StyledProductTitle variant="h1">{product.name}</StyledProductTitle>
      <StyledProductSubTitle>{product.cms.subTitle}</StyledProductSubTitle>
      {product.aggregateRating && product.aggregateRating.ratingValue > 0 && (
        <Rating aggreagateRating={product.aggregateRating} />
      )}
      <Pricing
        price={product.price}
        discount={product.discount}
        finalPrice={product.finalPrice}
        inStock={product.inStock}
      />
      {product.variantOf && smPlus && (
        <>
          <Variants variantId={product.variantOf} />
          {product.inStock && (
            <Box
              sx={{
                marginTop: "1rem",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {isViewCartButtonVisible ? (
                <StyledGreenButton href="/myCart" sx={{ width: "100%" }}>
                  {spinner ? (
                    <Spinner spinColor={theme.palette.neutral.main} />
                  ) : (
                    ""
                  )}
                  View cart &nbsp;{" "}
                  <Icon component={ShoppingCartCheckoutIcon} />
                </StyledGreenButton>
              ) : (
                <StyledLightGreenButton
                  onClick={handleAddToCart}
                  sx={{ width: "100%" }}
                >
                  {spinner ? (
                    <Spinner spinColor={theme.palette.primary.main} />
                  ) : (
                    ""
                  )}
                  Add To Cart &nbsp;{" "}
                  <Icon component={ShoppingCartCheckoutIcon} />
                </StyledLightGreenButton>
              )}
            </Box>
          )}
        </>
      )}

      
    </Box>
  );
}
